import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  DialogActions,
  DialogContent,
  Typography,
  Checkbox,
  Box,
  Card,
  CardContent,
  FormGroup,
  IconButton,
  Dialog,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { EyeOutlined, Html5Filled } from "@ant-design/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import {
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import HttpService from "../services/httpService";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { connect } from "react-redux";

function CostSummarySection(props) {
  const [loading, setLoadingState] = useState(false); // Local loading state
  const [editOpen, setEditOpen] = useState(false);
  const [mainImage, setMainImage] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [deleteModelIsOpen, setDeleteModelIsOpen] = useState(false);
  const [postModelIsOpen, setPostModelIsOpen] = useState(false);
  const [selectCategory, setSelectCategory] = useState("");
  const [allCategory, setAllCategory] = useState("");
  const [form, setForm] = useState({ title: "", imageUrl: "" });
  const [getAllCostSummary, setAllCostSummary] = useState([]);
  function editFunCloseHandle() {
    setEditOpen(false);
  }

  const costSummaryItemGet = async () => {
    try {
      setLoadingState(true);
      props.setLoading(true);
      const fetchData = await HttpService?.costBreakDownItemGet();
      setAllCostSummary(fetchData?.data || []);
    } catch (error) {
      setLoadingState(false);
      props.setLoading(false);
    }
  };

  const getAllCategoryFun = async () => {
    try {
      setLoadingState(true);
      props.setLoading(true);
      const fetchData = await HttpService?.getAllCategory();
      setAllCategory(fetchData?.data?.data || []);
    } catch (error) {
      setLoadingState(false);
      props.setLoading(false);
    }
  };

  const handleMainImageChange = async (event) => {
    props.setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", event.target.files[0]);
      const fileUploadRes = await HttpService.uploadFile(fd);
      setMainImage(fileUploadRes.data); // Make sure it's a URL or expected format
    } catch (error) {
      props.setSnackInfo("Something went wrong", "error");
    }
    props.setLoading(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (mainImage == "" || selectCategory == "") {
      props.setSnackInfo("please fill all the fields", "warning");
      return;
    }
    const obj = {
      imageUrl: mainImage,
      title: selectCategory,
    };
    props.setLoading(true);
    try {
      props.setLoading(true);
      const response = await HttpService.costBreakDownItemPut(sectionId, obj);
      costSummaryItemGet();
      setEditOpen(false);
      setMainImage("");
      setSelectCategory("");

      props.setLoading(false);
      props.setSnackInfo("Sucessfully Updated", "success");
    } catch (error) {
      props.setLoading(false);
    }
  };

  const deleteContentOfCommonWebQuotationFun = async () => {
    props.setLoading(true);
    try {
      props.setLoading(true);
      const response = await HttpService.costBreakDownItemDelete(sectionId);
      costSummaryItemGet();
      setDeleteModelIsOpen(false);
      props.setLoading(false);
      props.setSnackInfo("Item Deactivated Successfully", "success");
    } catch (error) {
      props.setLoading(false);
    }
  };

  const createSectionHandle = async (event) => {
    event.preventDefault();
    if (selectCategory == "" || mainImage == "") {
      props.setSnackInfo("please fill all the fields", "warning");
      return;
    }
    const obj = {
      imageUrl: mainImage,
      title: selectCategory,
    };

    props.setLoading(true);
    try {
      props.setLoading(true);
      const response = await HttpService.costBreakDownItemPost(obj);
      costSummaryItemGet();
      setPostModelIsOpen(false);
      setMainImage("");
      setSelectCategory("");
      props.setLoading(false);
      props.setSnackInfo("Sucessfully Created", "success");
    } catch (error) {
      props.setLoading(false);

      // Handle category already exists error
      if (error.response && error.response.status === 400) {
        props.setSnackInfo("Category already exists", "error");
      } else {
        props.setSnackInfo("Something went wrong. Please try again!", "error");
      }
    }
  };

  const handleEdit = (item) => {
    setEditOpen(true);
    setMainImage(item.imageUrl);
    setSelectCategory(item.title);
    setSectionId(item._id);
  };

  useEffect(() => {
    costSummaryItemGet();
    getAllCategoryFun();
  }, []);

  return (
    <div>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Box
          sx={{
            fontSize: "18px",
            fontWeight: "bold",
            color: "#FFF2EB",
            background: "#1C375D",
            padding: "10px 20px",
            borderRadius: "8px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            display: "inline-block",
            marginBottom: "5px",
            cursor: "pointer",
          }}
          onClick={() => {
            setPostModelIsOpen(true);
          }}
        >
          Create New Cost Break Down
        </Box>
      </Box>

      <Grid container spacing={3}>
        {getAllCostSummary?.length > 0 &&
          getAllCostSummary.map((item) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={item._id}>
              <Card style={{ position: "relative", height: "100%" }}>
                {/* Actions on Top */}
                <div
                  style={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    display: "flex",
                    flexDirection: "row",
                    gap: "6px",
                    zIndex: 1,
                    background: "rgba(255,255,255,0.9)",
                    // borderRadius: "8px",
                    // padding: "4px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  }}
                >
                  <IconButton
                    onClick={() => handleEdit(item)}
                    size="small"
                    color="primary"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      setSectionId(item?._id);
                      setDeleteModelIsOpen(true);
                    }}
                    size="small"
                    color="error"
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </div>

                {/* Image */}
                <div
                  style={{
                    height: "180px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f9f9f9",
                    padding: "8px",
                  }}
                >
                  <img
                    src={item.imageUrl}
                    alt={item.name}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>

                {/* Title */}
                <CardContent>
                  <Typography variant="h6" component="div" noWrap>
                    {item.title}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
      </Grid>

      {/* Dialog Box for Edit content */}
      <Dialog
        open={editOpen}
        onClose={() => {}} // Prevent closing on backdrop click
        maxWidth="lg"
        PaperProps={{
          style: {
            width: "40%",
            maxHeight: "50vh",
          },
        }}
        BackdropProps={{
          style: { pointerEvents: "none" }, // Disable clicking outside
        }}
      >
        <DialogContent>
          <Box onClick={(e) => e.stopPropagation()}>
            {" "}
            {/* Prevent backdrop close */}
            <Card sx={{ maxWidth: 500, mt: 4, p: 2 }}>
              <CardContent>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="h5" gutterBottom>
                    Edit Content
                  </Typography>
                </Box>
                <form onSubmit={handleSubmit}>
                  <FormControl style={{ m: 1, minWidth: 300 }} size="small">
                    <InputLabel>Select Category</InputLabel>
                    <Select
                      value={selectCategory}
                      onChange={(e) => setSelectCategory(e.target.value)}
                    >
                      {allCategory.length > 0 &&
                        allCategory?.map((ele) => {
                          return (
                            <MenuItem value={ele?.name}>{ele?.name}</MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                  <Button
                    variant="contained"
                    component="label"
                    fullWidth
                    style={{
                      backgroundColor: "#355025",
                      color: "#FFF2EB",
                      marginTop: "10px",
                    }}
                  >
                    <div>
                      Upload Main Image
                      {mainImage?.name && <span>, {mainImage.name}</span>}
                    </div>
                    <input
                      type="file"
                      hidden
                      accept=".png, .jpg, .jpeg, .webp"
                      onChange={handleMainImageChange}
                    />
                    <FormGroup style={{ marginLeft: "10px" }}>
                      <FormControlLabel
                        control={
                          <Checkbox checked={!!mainImage} color="primary" />
                        }
                      />
                    </FormGroup>
                  </Button>
                </form>
              </CardContent>
            </Card>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            style={{ backgroundColor: "#355025" }}
            variant="contained"
            color="primary"
            onClick={(e) => handleSubmit(e)}
          >
            Edit
          </Button>
          <Button
            onClick={() => {
              editFunCloseHandle();
              setMainImage("");
            }}
            variant="contained"
            color="secondary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Box for delete Document */}
      <Dialog
        open={deleteModelIsOpen}
        onClose={() => {
          setDeleteModelIsOpen(false);
        }}
        maxWidth="lg" // Adjust maxWidth ('xs', 'sm', 'md', 'lg', 'xl' for default sizes)
        PaperProps={{
          style: {
            width: "25%", // Set custom width
            maxHeight: "50vh", // Optionally limit height
          },
        }}
      >
        <DialogContent>
          <Typography variant="h6">
            {" "}
            Are you sure you want to delete it?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            style={
              {
                //   backgroundColor: "red",
              }
            }
            variant="contained"
            color="primary"
            onClick={() => {
              deleteContentOfCommonWebQuotationFun();
            }}
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              setDeleteModelIsOpen(false);
            }}
            variant="contained"
            color="secondary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Box for Post Document */}
      <Dialog
        open={postModelIsOpen}
        onClose={() => {
          setPostModelIsOpen(false);
        }}
        maxWidth="lg" // Adjust maxWidth ('xs', 'sm', 'md', 'lg', 'xl' for default sizes)
        PaperProps={{
          style: {
            width: "50%", // Set custom width
            maxHeight: "50vh", // Optionally limit height
          },
        }}
      >
        <DialogContent>
          <Card
            sx={{
              maxWidth: 500,
              // mx: "auto",
              mt: 4,
              p: 2,
              // width:"50%"
            }}
          >
            <CardContent>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="h5" gutterBottom>
                  Post Content
                </Typography>
              </Box>
              <form onSubmit={handleSubmit}>
                <FormControl style={{ m: 1, minWidth: 300 }} size="small">
                  <InputLabel>Select Category</InputLabel>
                  <Select
                    value={selectCategory}
                    onChange={(e) => setSelectCategory(e.target.value)}
                  >
                    {allCategory.length > 0 &&
                      allCategory?.map((ele) => {
                        return (
                          <MenuItem value={ele?.name}>{ele?.name}</MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
                <Button
                  variant="contained"
                  component="label"
                  fullWidth
                  style={{
                    mt: 2,
                    backgroundColor: "#355025",
                    color: "#FFF2EB",
                    "&:hover": { backgroundColor: "#355025" },
                    marginTop: "10px",
                  }}
                >
                  <div>
                    Upload Image
                    {mainImage?.name && <span>, {mainImage.name}</span>}
                  </div>
                  <input
                    type="file"
                    hidden
                    accept=".png, .jpg, .jpeg, .webp"
                    onChange={handleMainImageChange}
                  />
                  <FormGroup style={{ marginLeft: "10px" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={mainImage !== "" ? true : false}
                          color="primary" // Change color (primary, secondary, default)
                        />
                      }
                    />
                  </FormGroup>
                </Button>
              </form>
            </CardContent>
          </Card>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={(e) => {
              createSectionHandle(e);
            }}
          >
            Save
          </Button>
          <Button
            onClick={() => {
              setPostModelIsOpen(false);
              setMainImage("");
              setSelectCategory("");
            }}
            variant="contained"
            color="secondary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default connect(null, { setLoading, setSnackInfo })(CostSummarySection);
